/* Delfino — hd-handoff.js (30.09.2026): pagina produsului-pachet, venind din „Harta durerii”.

   Butonul „Comandă cu plata la livrare” din rezultatul testului duce aici:
     /products/<pachet>?hd=<token>#dl-cod-form-slot

   Doar când adresa are un `hd` valid (32 de caractere hexa), scriptul:
     1. trimite o singură dată pe token `form_opened` spre Worker (`POST /hd/event`, contractul din
        docs/superpowers/specs/2026-09-30-harta-durerii-design.md), în clipa în care formularul Releasit
        a apărut și e pe ecran — pâlnia din Merlo vede așa „a deschis formularul”;
     2. derulează O DATĂ la formular, după ce a apărut (vine asincron, iar tema îl mută în slotul de jos),
        și doar dacă omul n-a derulat deja singur — ca scan-handoff.js.
   Adresa Worker-ului e cea lăsată în browser de test (localStorage `hd:worker`); fără ea nu pleacă nimic.

   Ce NU face, niciodată: nu trimite formularul, nu apasă niciun buton, nu atinge vreun câmp. Nu se
   amestecă în trimiterea scanerului (`?ns_qty=…`, scan-handoff.js): fiecare își citește parametrul lui.

   Globala expusă: DLHartaHandoff (`parse` e pură și merge și în Node, pentru teste). */
(function (root) {
  'use strict';

  var TOKEN_RE = /^[0-9a-f]{32}$/;
  /* ACEEAȘI cheie și aceeași regulă ca în harta-durerii.js (testul le compară). */
  var WORKER_KEY = 'hd:worker';
  var WORKER_URL_RE = /^(https:\/\/[A-Za-z0-9.-]+(:\d{1,5})?|http:\/\/(localhost|127\.0\.0\.1)(:\d{1,5})?)(\/[A-Za-z0-9._~\/-]*)?$/;
  var SENT_PREFIX = 'hd:act:';

  function own(map, key) { return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : undefined; }

  /* Tokenul testului din `location.search`; gol = nu venim din test. Primul `hd` câștigă. */
  function parse(search) {
    var query = String(search || '').replace(/^\?/, '');
    if (!query) return '';
    var params = {};
    query.split('&').forEach(function (pair) {
      if (!pair) return;
      var at = pair.indexOf('=');
      var key = at < 0 ? pair : pair.slice(0, at);
      var value = at < 0 ? '' : pair.slice(at + 1);
      try {
        key = decodeURIComponent(key.replace(/\+/g, ' '));
        value = decodeURIComponent(value.replace(/\+/g, ' '));
      } catch (e) { return; }
      if (own(params, key) === undefined) params[key] = value;
    });
    var token = own(params, 'hd');
    return typeof token === 'string' && TOKEN_RE.test(token) ? token : '';
  }

  root.DLHartaHandoff = { parse: parse };

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var FORM_SEL = '#_rsi-cod-form-modal-form';
  var RSI_TRIGGER_SEL = '._rsi-buy-now-button, [class*="_rsi-buy-now"], [data-dl-rsi-hook], [data-dl-order-btn], [data-dl-hero-order]';
  var POLL_MS = 300;
  var WAIT_MS = 30000;
  var SETTLE_MS = 700;
  var SCROLL_WINDOW_MS = 12000;

  function now() { return Date.now(); }

  function visible(el) {
    if (!el || !el.getClientRects || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    return !cs || (cs.visibility !== 'hidden' && cs.display !== 'none');
  }

  function inViewport(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return r.height > 0 && r.top < vh && r.bottom > 0;
  }

  function reducedMotion() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }

  function workerBase() {
    var value = '';
    try { value = window.localStorage ? String(window.localStorage.getItem(WORKER_KEY) || '') : ''; } catch (e) { value = ''; }
    return WORKER_URL_RE.test(value) ? value.replace(/\/+$/, '') : '';
  }

  function run(token) {
    var startedAt = now();
    var until = startedAt + WAIT_MS;
    var timer = null;
    var formSince = 0;
    var scrolled = false;
    var reported = false;
    var userMoved = false;

    /* `form_opened`, o dată pe token (și peste reîncărcări, prin sessionStorage). */
    function report() {
      if (reported) return;
      reported = true;
      var key = SENT_PREFIX + token;
      var store = null;
      try { store = window.sessionStorage; } catch (e) { store = null; }
      try { if (store && store.getItem(key)) return; } catch (e) { /* stocare blocată */ }
      var base = workerBase();
      if (!base || typeof window.fetch !== 'function') return;
      try {
        var req = window.fetch(base + '/hd/event', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token, name: 'form_opened' }),
          keepalive: true,
          credentials: 'omit',
          mode: 'cors'
        });
        if (req && typeof req.catch === 'function') req.catch(function () { /* pâlnia nu strică pagina */ });
      } catch (e) { return; }
      try { if (store) store.setItem(key, '1'); } catch (e) { /* idem */ }
    }

    function findForm() {
      var forms = document.querySelectorAll(FORM_SEL);
      for (var i = 0; i < forms.length; i++) if (visible(forms[i])) return forms[i];
      return null;
    }
    function embedded(form) {
      return !!(form.closest && form.closest('._rsi-cod-form-embed-container, [data-dl-cod-slot]'));
    }
    function scrollTo(form) {
      var target = (form.closest && form.closest('._rsi-cod-form-embed-container')) || form;
      var header = document.querySelector('[data-dl-header], .dl-header, header');
      var offset = (header ? Math.min(header.getBoundingClientRect().height, 140) : 0) + 12;
      var top = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
      try { window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion() ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, top)); }
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function tick() {
      var t = now();
      if (t > until) { stop(); return; }
      var form = findForm();
      if (!form) return;
      if (!formSince) formSince = t;
      if (!scrolled && !userMoved && embedded(form) && t - formSince >= SETTLE_MS && t - startedAt <= SCROLL_WINDOW_MS) {
        scrolled = true;
        scrollTo(form);
      }
      if (inViewport(form)) { report(); stop(); }
    }

    function kick(ms) {
      until = Math.max(until, now() + ms);
      if (!timer) timer = setInterval(tick, POLL_MS);
    }

    /* Omul derulează singur → nu-i mai smulgem pagina; un click pe butoanele Releasit (popup) → mai
       așteptăm formularul. Doar evenimentele ADEVĂRATE. */
    ['wheel', 'touchmove', 'keydown'].forEach(function (type) {
      window.addEventListener(type, function (e) { if (e && e.isTrusted) userMoved = true; }, { passive: true });
    });
    document.addEventListener('click', function (e) {
      if (!e || !e.isTrusted || reported) return;
      var target = e.target && e.target.closest ? e.target : null;
      if (target && target.closest(RSI_TRIGGER_SEL)) kick(10000);
    }, true);

    kick(WAIT_MS);
    tick();
    return { tick: tick, stop: stop };
  }

  function boot() {
    var token = '';
    try { token = parse(window.location.search); } catch (e) { token = ''; }
    if (!token) return;
    setTimeout(function () { root.DLHartaHandoff.active = run(token); }, 0);
  }

  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})(typeof globalThis !== 'undefined' ? globalThis : this);
